<template>
    <div v-if="weerstations.length != 0" class="wrapper">
        <item-form
                :model="model"
                :weerstations="weerstations"
                :voorspellingsplaatsen="voorspellingsplaatsen"
                :isEditing="false"
                @save-item="addItem">
        </item-form>

        <b-modal title="Toevoegen" size="sm" class="modal-danger" v-model="warningModal" @ok="closedialog">
            FOUT: Bedrijf werd niet toegevoegd! {{errormsg}}
        </b-modal>
    </div>
</template>

<script>
    import api from '../../api/bedrijf';
    import ItemForm from './Form';

    export default {
        data () {
            return {
                warningModal: false,
                errormsg: '',
                weerstations: [],
                voorspellingsplaatsen: [],
                model: {
                },
            };
        },
        created () {
            api.getDetailBedrijf(0).then((response) => {
                this.weerstations = response.data.weerstations;
                this.voorspellingsplaatsen = response.data.voorspellingsplaatsen;
            });
        },
        methods: {
            addItem (model) {
                api.addBedrijf(model).then(() => {
                    this.$router.replace('/beheer/bedrijf');
                },
                (error) => {
                    this.errormsg = error.message;
                    this.warningModal = true;
                });
            },
            closedialog () {
                this.warningModal = false;
            },
        },
        components: {
            'item-form': ItemForm,
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/bedrijf/New.vue